<template>
  <div style="padding: 15px">
    <van-empty v-if="list.length == 0" description="暂未购买优惠券" />
    <ul v-else>
      <li v-for="item in list" :key="item.id">
        <div class="card">
          <div class="zhong">
            <div class="round">
              <div class="text">{{ item.couponPrice }}元</div>
            </div>
          </div>
          <div class="content">
            <div class="name">{{ item.couponName }}</div>
            <div class="date">过期时间:{{ item.endTime }}</div>
            <div class="order">兑换单号:{{ item.orderNumber }}</div>
          </div>
          <div class="zhong">
            <div
              :class="
                item.state == 0
                  ? 'butten'
                  : item.state == 1
                  ? 'butten active-1'
                  : 'butten active-3'
              "
            >
              {{
                item.state == 0
                  ? "待使用"
                  : item.state == 1
                  ? "已使用"
                  : "已过期"
              }}
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import { seriesCouponOrderList } from "@/api/discount";
  export default {
    data() {
      return {
        list: [],
      };
    },
    created() {},
    mounted() {
      this.seriesCouponOrderList();
    },

    methods: {
      seriesCouponOrderList() {
        seriesCouponOrderList().then((res) => {
          this.list = res.data;
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  .card {
    display: flex;
    justify-content: space-between;
    padding: 5px;
    height: 60px;
    margin-bottom: 15px;
    border-radius: 10px;
    border: 1px #fe932f dashed;

    .zhong {
      display: flex;
      justify-content: center;
      align-items: center;

      .round {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        width: 50px;
        height: 50px;
        color: #ffffff;

        border-radius: 50%;
        background: #fff2ff;
        // background-image: linear-gradient(to bottom right, #ccfbff, #eeeeee);
        .text {
          background: #fb115a;
          padding: 2px;
          border-radius: 3px;
        }
      }
      .butten {
        font-size: 14px;
        width: 60px;
        height: 30px;
        text-align: center;
        color: #ffffff;
        line-height: 30px;
        border-radius: 10px;
        background: #fe932f;
      }

      .active-1 {
        background: #d8d8d8;
      }
      .active-3 {
        background: red;
      }
    }
    .content {
      width: 280px;
      margin-left: 10px;
      text-align: left;
      .name {
        font-size: 14px;
      }
      .date {
        color: #cccccc;
        font-size: 12px;
        margin-top: 5px;
      }
      .order {
        color: #cccccc;
        font-size: 12px;
        margin-top: 5px;
      }
    }
  }
</style>
